import { render, staticRenderFns } from "./GenericTableStringCell.vue?vue&type=template&id=cb2d7f16&scoped=true"
import script from "./GenericTableStringCell.vue?vue&type=script&lang=ts"
export * from "./GenericTableStringCell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2d7f16",
  null
  
)

export default component.exports